// extracted by mini-css-extract-plugin
module.exports = {"footer":"TheFooter_footer_2VgVs","textBox":"TheFooter_textBox_22BhI","socialList":"TheFooter_socialList_2BFI8","socialItem":"TheFooter_socialItem_2M1dm"};